import App from './App.svelte';
const app = new App({
    target: document.body,
    props: {
        db: [
            {
                name: "EP08-006",
                vmax: "140",
                leng: "16",
                mass: "80",
                typ: "pasażerski",
                painting: "InterCity - pomarańczowe"
            },
            {
                name: "EP08-006v2",
                vmax: "140",
                leng: "16",
                mass: "80",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "ET41-061	",
                vmax: "120",
                leng: "32",
                mass: "167",
                typ: "towarowy",
                painting: "klasyczne - żółte czoło"
            },
            {
                name: "ET41-072",
                vmax: "120",
                leng: "32",
                mass: "167",
                typ: "towarowy",
                painting: "klasyczne"
            },
            {
                name: "ET41-074",
                vmax: "120",
                leng: "32",
                mass: "167",
                typ: "towarowy",
                painting: "klasyczne"
            },
            {
                name: "ET41-144",
                vmax: "120",
                leng: "32",
                mass: "167",
                typ: "towarowy",
                painting: "PKP Cargo"
            },
            {
                name: "ET41-154",
                vmax: "120",
                leng: "32",
                mass: "167",
                typ: "towarowy",
                painting: "klasyczne"
            },
            {
                name: "EU07-334",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "InterCity"
            },
            {
                name: "EU07-409",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "klasyczne"
            },
            {
                name: "EU07-418",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "klasyczne - żółte czoło"
            },
            {
                name: "EU07-515",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "InterCity"
            },
            {
                name: "EU07-545",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "InterCity"
            },
            {
                name: "EP07-1031",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-1056",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-384",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-424",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "klasyczne"
            },
            {
                name: "EU07-324",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "InterCity"
            },
            {
                name: "EP07-1008",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "PKP Przewozy Regionalne"
            },
            {
                name: "EP07-1009",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-1025",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-1038",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-1039",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-1043",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-1054",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-1025",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-1055",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "PKP Przewozy Regionalne"
            },
            {
                name: "EP07-335",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-338",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "klasyczne"
            },
            {
                name: "EP07-355",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-356",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "klasyczne - żółte czoło"
            },
            {
                name: "EP07-370",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "klasyczne"
            },
            {
                name: "EP07-385",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "klasyczne"
            },
            {
                name: "EP07-391",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-408",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "PKP Cargo Spółka Akcyjna"
            },
            {
                name: "EP07-444",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-480",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-544",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EU07-368",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "InterCity"
            },
            {
                name: "EU07-1518",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "PKP Cargo"
            },
            {
                name: "EU07-368",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "klasyczne"
            },
            {
                name: "EU07-421",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "InterCity"
            },
            {
                name: "EU07-475",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "klasyczne"
            },
            {
                name: "EU07-512",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "klasyczne"
            },
            {
                name: "EP07-135",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "klasyczne"
            },
            {
                name: "EU07-001",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "klasyczne"
            },
            {
                name: "EU07-015",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "InterCity"
            },
            {
                name: "EU07-032",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "klasyczne"
            },
            {
                name: "EU07-150",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "InterCity"
            },
            {
                name: "EU07-1518",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "klasyczne"
            },
            {
                name: "EU07-171",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "klasyczne"
            },
            {
                name: "EU07-172",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "PKP Cargo"
            },
            {
                name: "EU07-222",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "PKP Przewozy Regionalne"
            },
            {
                name: "EU07-077",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "klasyczne"
            },
            {
                name: "EP07-1002",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EU07E-038",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "ECCO Rail"
            },
            {
                name: "EP07-1048",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EP07-242",
                vmax: 120,
                leng: "16",
                mass: "83",
                typ: "pasażerski",
                painting: "InterCity"
            },
            {
                name: "EU07-088",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "ECCO Rail"
            },
            {
                name: "EU07-123E",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "PKP Cargo"
            },
            {
                name: "EU07-141",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "idk"
            },
            {
                name: "EU07-145",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "CTL Logistic"
            },
            {
                name: "EU07-167",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "CTL Logistic"
            },
            {
                name: "EU07-234",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "InterCity"
            },
            {
                name: "EU07-237E",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "PKP Cargo"
            },
            {
                name: "EU07-242",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "CTL Logistic"
            },
            {
                name: "EU07E-082",
                vmax: "120",
                leng: "16",
                mass: "83",
                typ: "uniwersalny",
                painting: "ECCO Rail"
            },
            {
                name: "EU06-18",
                vmax: "120",
                leng: "16",
                mass: "80",
                typ: "uniwersalny",
                painting: "klasyczne"
            },
            {
                name: "SM42-091",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "klasyczne"
            },
            {
                name: "SM42-2612",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "ORLEN KolTrans"
            },
            {
                name: "SM42-2648",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "PNI"
            },
            {
                name: "SM42-284",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "klasyczne"
            },
            {
                name: "SM42-302",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "klasyczne"
            },
            {
                name: "SM42-329",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "PKP Przewozy Regionalne"
            },
            {
                name: "SM42-329_PLREG",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "POLRegio"
            },
            {
                name: "SM42-404",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "klasyczne"
            },
            {
                name: "SM42-468",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "PKP Cargo"
            },
            {
                name: "SM42-483",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "klasyczne"
            },
            {
                name: "SM42-506",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "InterCity"
            },
            {
                name: "SM42-1121",
                vmax: "90",
                leng: "14",
                mass: "74",
                typ: "manewrowa",
                painting: "PKP Cargo"
            },
            {
                name: "SN81-001",
                vmax: "90",
                leng: "14",
                mass: "23",
                typ: "szynobus",
                painting: "klasyczne"
            },
            {
                name: "111a_Grafitti_1",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "PKP + grafitti"
            },
            {
                name: "111a_PKP_Bwxz_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "Retro"
            },
            {
                name: "110a_PKP_Bcwxz_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "110a",
                painting: "Retro"
            },
            {
                name: "110a_PKPIC_Bcdu_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "110a",
                painting: "PKPIC"
            },
            {
                name: "110a_PKPIC_Bcdu_02",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "110a",
                painting: "PKPIC"
            },
            {
                name: "111a_PKP_Bdnu_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "PKP"
            },
            {
                name: "111a_PKP_Bdnu_02",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "PKP"
            },
            {
                name: "111a_PKP_Bnouz_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "PKP"
            },
            {
                name: "111a_PKP_Brdu_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "PKP"
            },
            {
                name: "111a_PKPIC_B10ou_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "Intercity"
            },
            {
                name: "111a_PKPIC_B9nopuvz_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "Intercity + T-Mobile"
            },
            {
                name: "111a_PKPIC_B9nopuvz_02",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "Intercity"
            },
            {
                name: "111a_PKPIC_B9ouv_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "PKP"
            },
            {
                name: "111a_PKPIC_Bnouz_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "Intercity"
            },
            {
                name: "111a_PRREG_A9ou_01",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "interREGIO"
            },
            {
                name: "111a_PRREG_A9ou_02",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "REGIOexpress"
            },
            {
                name: "111a_PRREG_A9ouy_01",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "Przewozy Regionalny wagon multimedialny"
            },
            {
                name: "111a_PRREG_B10_01",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "Przewozy Regionalne"
            },
            {
                name: "111a_PRREG_Bbnopuvz_01",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "Przewozy Regionalne"
            },
            {
                name: "111a_PRREG_Bbnopuvz_02",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "111a",
                painting: "regioEXPRESS"
            },
            {
                name: "112a_A9ou_511-6",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "Retro"
            },
            {
                name: "112a_A9ouy_172-5",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "Retro"
            },
            {
                name: "112a_A9ouy_501-7",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "Retro"
            },
            {
                name: "112a_PKP_A9nou_01",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "PKP"
            },
            {
                name: "112a_PKP_A9ou_02",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "PKP"
            },
            {
                name: "112a_PKP_Adnu_01",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "PKP"
            },
            {
                name: "112a_PKP_Adu_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "PKP"
            },
            {
                name: "112a_PKP_Awxz_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "Retro"
            },
            {
                name: "112a_PKPIC_A9ou_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "Intercity"
            },
            {
                name: "112a_PKPIC_A9ou_02",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "Intercity TLK"
            },
            {
                name: "112a_PRREG_A9ou_01",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "REGIOexpress"
            },
            {
                name: "112a_PRREG_A9ou_02",
                vmax: "120",
                leng: "25",
                mass: "40",
                typ: "112a",
                painting: "Przewozy Regionalne"
            },
            {
                name: "113a_PKP_BJwxz_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "113a",
                painting: "Retro Wars"
            },
            {
                name: "113a_PKP_WRbd_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "113a",
                painting: "PKP Wars"
            },
            {
                name: "113a_PKPIC_WRbd_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "113a",
                painting: "Intercity Wars"
            },
            {
                name: "113a_PLPREG_Wro_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "113a",
                painting: "Przewozy Regionalne Wars"
            },
            {
                name: "120a_PRREG_B11p_01",
                vmax: "140",
                leng: "25",
                mass: "45",
                typ: "120a",
                painting: "POLRegio"
            },
            {
                name: "120a_PRREG_B11p_02",
                vmax: "140",
                leng: "25",
                mass: "45",
                typ: "120a",
                painting: "Przewozy Regionalne"
            },
            {
                name: "120a_PRREG_B11pv_01",
                vmax: "140",
                leng: "25",
                mass: "45",
                typ: "120a",
                painting: "POLRegio"
            },
            {
                name: "120a_PRREG_B51p_01",
                vmax: "140",
                leng: "25",
                mass: "45",
                typ: "120a",
                painting: "Przewozy Regionalne"
            },
            {
                name: "120a_PRREG_B51p_02",
                vmax: "140",
                leng: "25",
                mass: "45",
                typ: "120a",
                painting: "Przewozy Regionalne"
            },
            {
                name: "120a_PRREG_B51p_03",
                vmax: "140",
                leng: "25",
                mass: "45",
                typ: "120a",
                painting: "Przewozy Regionalne"
            },
            {
                name: "120a_PRREG_B51p_04",
                vmax: "140",
                leng: "25",
                mass: "45",
                typ: "120a",
                painting: "Przewozy Regionalne"
            },
            {
                name: "120a_PRREG_B9pv_01",
                vmax: "140",
                leng: "25",
                mass: "45",
                typ: "120a",
                painting: "Przewozy Regionalne"
            },
            {
                name: "154a_PKP_B10mnouz_01",
                vmax: "200",
                leng: "26",
                mass: "55",
                typ: "154a",
                painting: "PKP"
            },
            {
                name: "154a_PKPIC_B10mnouz_01",
                vmax: "200",
                leng: "26",
                mass: "55",
                typ: "154a",
                painting: "Intercity"
            },
            {
                name: "154a_PKPIC_B10mnouz_02",
                vmax: "200",
                leng: "26",
                mass: "55",
                typ: "154a",
                painting: "Intercity BWE Express"
            },
            {
                name: "158a_PKPIC_A9mnopuz_01",
                vmax: "200",
                leng: "26",
                mass: "50",
                typ: "158a",
                painting: "Intercity"
            },
            {
                name: "159a_PKPIC_B9mnopuz_01",
                vmax: "200",
                leng: "26",
                mass: "50",
                typ: "159a",
                painting: "Intercity"
            },
            {
                name: "504a_PKP_Bckd_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "504a",
                painting: "PKP"
            },
            {
                name: "504a_PKP_S_02",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "504a",
                painting: "Pomiarowy"
            },
            {
                name: "504a_PKP_Sd_03",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "504a",
                painting: "PKP"
            },
            {
                name: "504a_PKP_Sk_01",
                vmax: "160",
                leng: "25",
                mass: "40",
                typ: "504a",
                painting: "Retro"
            },
            {
                name: "612a_PKPIC_BD4osuv_01",
                vmax: "160",
                leng: "25",
                mass: "43",
                typ: "612a",
                painting: "Intercity"
            },
            {
                name: "Bau84_CD_B10nou_01",
                vmax: "140",
                leng: "25",
                mass: "40",
                typ: "Bau84",
                painting: "Ceskie Drahny"
            },
            {
                name: "Bau84_PKP_As_01",
                vmax: "140",
                leng: "26",
                mass: "40",
                typ: "Bau84",
                painting: "Retro"
            },
            {
                name: "Bau84_PKP_B10nou_01",
                vmax: "140",
                leng: "25",
                mass: "40",
                typ: "Bau84",
                painting: "PKP"
            },
            {
                name: "Bau84_PKP_B10nou_02",
                vmax: "140",
                leng: "25",
                mass: "40",
                typ: "Bau84",
                painting: "PKP"
            },
            {
                name: "Bau84_PKPIC_B10nou_01",
                vmax: "140",
                leng: "25",
                mass: "40",
                typ: "Bau84",
                painting: "Intercity"
            },
            {
                name: "Bau84_PKPIC_B10nou_02",
                vmax: "140",
                leng: "26",
                mass: "40",
                typ: "Bau84",
                painting: "Intercity TLK"
            },
            {
                name: "Gor77_PKP_Bhp_01",
                vmax: "120",
                leng: "71",
                mass: "132",
                typ: "Gor77",
                painting: "Retro"
            },
            {
                name: "Gor77_PKP_Bhp_02",
                vmax: "120",
                leng: "71",
                mass: "132",
                typ: "Gor77",
                painting: "PKP"
            },
            {
                name: "Gor77_PKP_Bhp_03",
                vmax: "120",
                leng: "71",
                mass: "132",
                typ: "Gor77",
                painting: "PKP"
            },
            {
                name: "Gor89_CD_Bmto_01",
                vmax: "120",
                leng: "29",
                mass: "42",
                typ: "Gor89",
                painting: "Ceskie Drahny"
            },
            {
                name: "Gor89_CD_Bmto_02",
                vmax: "120",
                leng: "29",
                mass: "42",
                typ: "Gor89",
                painting: "Ceskie Drahny"
            },
            {
                name: "Gor89_PKP_B16mnopux_01",
                vmax: "120",
                leng: "29",
                mass: "42",
                typ: "Gor89",
                painting: "PKP"
            },
            {
                name: "Gor89_PKP_B16mnopux_02",
                vmax: "120",
                leng: "29",
                mass: "42",
                typ: "Gor89",
                painting: "PKP"
            },
            {
                name: "Gor89_PKP_B16mnopux_03",
                vmax: "120",
                leng: "29",
                mass: "42",
                typ: "Gor89",
                painting: "PKP"
            },
            {
                name: "Gor89_PKP_B16mnopux_04",
                vmax: "120",
                leng: "29",
                mass: "42",
                typ: "Gor89",
                painting: "PKP"
            },
            {
                name: "Gor89_PKP_B16mnopux_05",
                vmax: "120",
                leng: "29",
                mass: "42",
                typ: "Gor89",
                painting: "PKP"
            },
            {
                name: "Gor89_PKP_B16mnopux_06",
                vmax: "120",
                leng: "29",
                mass: "42",
                typ: "Gor89",
                painting: "POLRegio"
            },
        ]
    }
});
export default app;
